(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-product-cart"] && !Shopify.designMode) return;
  try {
    
  const cartRelatedProductSection = document.querySelector('.cart-related-product-section');

  const fetchCartProducts = async () => {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      return cart.items.length > 0 ? cart.items[0].product_id : null; // Retourne l'ID du premier produit ou null
    } catch (e) {
      console.error('Erreur lors de la récupération du panier :', e);
      return null;
    }
  };

  const loadCartRecommendations = async () => {
    try {
      const productId = await fetchCartProducts();

      if (!productId) {
        cartRelatedProductSection.querySelector('.product-items').innerHTML = '<p>Votre panier est vide.</p>';
        return;
      }

      // Générer l'URL avec l'ID du premier produit dans le panier
      const url = `${cartRelatedProductSection.dataset.url}&product_id=${productId}&limit=4&intent=related`;

      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;

          // Rechercher uniquement les éléments de produits
          const productItems = html.querySelectorAll('.product-item');

          if (productItems.length > 0) {
            const productItemsContainer = cartRelatedProductSection.querySelector('.product-items');
            productItemsContainer.innerHTML = ''; // Nettoyer avant d'insérer les nouveaux produits
            productItems.forEach(product => productItemsContainer.appendChild(product));
          } else {
            cartRelatedProductSection.querySelector('.product-items').innerHTML = '<p>Aucune recommandation trouvée.</p>';
          }
        })
        .catch(e => {
          console.error('Erreur lors du chargement des recommandations :', e);
          cartRelatedProductSection.querySelector('.product-items').innerHTML = '<p>Erreur lors du chargement des recommandations.</p>';
        });
    } catch (e) {
      console.error('Erreur générale :', e);
      cartRelatedProductSection.querySelector('.product-items').innerHTML = '<p>Erreur lors du chargement des recommandations.</p>';
    }
  };

  loadCartRecommendations();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
